import { useCallback, useEffect, useState } from 'react';
import { useNavigate, unstable_useBlocker as useBlocker, useLocation } from 'react-router-dom';
import { RequestKind } from '../types';
import { IS_ON_IFRAME } from '../constants';
import { removeSearch } from '../utils';
const isLocationEqual = (loc, compareLoc) => {
    const { key: vkey, ...val } = loc || {};
    const { key: ckey, ...compare } = compareLoc;
    return Object.entries(val).every(([k, v]) => compare[k] === v);
};
export function useNavigator(postMessage) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isFirstNavStarted, setIsFirstNavStarted] = useState(false);
    const [isFirstNavDone, setIsFirstNavDone] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(location.pathname);
    const [confirmedNavigation, setConfirmedNavigation] = useState('');
    const confirmNavigation = useCallback((newLocation) => {
        const normalizedLocation = !newLocation.startsWith('/') ? '/' + newLocation : newLocation;
        setCurrentLocation(removeSearch(normalizedLocation));
        setConfirmedNavigation(newLocation);
        if (!isFirstNavStarted) {
            setIsFirstNavStarted(true);
        }
    }, []);
    const handleBlockedNavigation = useCallback(({ currentLocation, nextLocation, }) => {
        if (!confirmedNavigation && !isLocationEqual(currentLocation, nextLocation)) {
            postMessage({
                requestKind: RequestKind.CHANGE_LOCATION,
                location: `${nextLocation.pathname}${nextLocation.search}`,
            });
        }
        return IS_ON_IFRAME && !confirmedNavigation;
    }, [confirmedNavigation]);
    useBlocker(handleBlockedNavigation);
    useEffect(() => {
        if (confirmedNavigation) {
            setConfirmedNavigation('');
            navigate(confirmedNavigation);
        }
    }, [confirmedNavigation]);
    if (!isFirstNavDone && isFirstNavStarted && currentLocation === location.pathname) {
        setIsFirstNavDone(true);
    }
    return {
        navigate: confirmNavigation,
        isNavigationInitialized: isFirstNavDone,
    };
}
